import React from 'react';

import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { Mention, MentionsInput } from 'react-mentions';

import mentionsInputStyle from './mentionsInputStyle'; // Estilo base para notas

// Estilo para el contador de caracteres
const TextCounter = styled('span')`
    display: block;
    font-size: 0.75em;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0.25px;
    text-align: end;
`;

const ReactHookFormMentionsInput = ({
    control,
    data = [], // Datos para las menciones (@usuario)
    hasCounter = false, // Mostrar contador de caracteres
    isMessage = false, // Indica si es un mensaje (true) o una nota (false)
    maxLength, // Límite máximo de caracteres
    mentionStyle, // Estilo para las menciones
    name, // Nombre del campo en el formulario
    placeholder, // Texto placeholder
    ...rest // Otras props adicionales
}) => {
    // Estilos según si es mensaje o nota
    const inputStyle = isMessage
        ? {
              ...mentionsInputStyle,
              control: {
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  padding: '8.5px 14px',
              },
          }
        : mentionsInputStyle;

    return (
        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, value, ref },
                fieldState: { error },
            }) => (
                <>
                    <div ref={ref}>
                        <MentionsInput
                            value={value || ''}
                            onChange={(e) => onChange(e.target.value)}
                            placeholder={placeholder}
                            style={inputStyle}
                            {...rest}
                        >
                            <Mention
                                trigger="@"
                                data={data}
                                style={mentionStyle}
                            />
                        </MentionsInput>
                    </div>

                    {error && (
                        <span style={{ color: 'red', fontSize: '0.75em' }}>
                            {error.message}
                        </span>
                    )}

                    {hasCounter && maxLength && (
                        <TextCounter>
                            {(value || '').length}/{maxLength}
                        </TextCounter>
                    )}
                </>
            )}
        />
    );
};

ReactHookFormMentionsInput.propTypes = {
    control: PropTypes.object.isRequired,
    data: PropTypes.arrayOf(
        PropTypes.shape({
            display: PropTypes.string,
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    ),
    hasCounter: PropTypes.bool,
    isMessage: PropTypes.bool,
    maxLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    mentionStyle: PropTypes.object,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
};

export default ReactHookFormMentionsInput;
